import { render } from "./ChargePage.vue?vue&type=template&id=9a3b38e0&scoped=true"
import script from "./_ChargePage.js?vue&type=script&lang=js"
export * from "./_ChargePage.js?vue&type=script&lang=js"

import "./_ChargePage.less?vue&type=style&index=0&id=9a3b38e0&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3b38e0"]])

export default __exports__